import React from 'react';
import ReactDOM from 'react-dom/client';
import { useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { prod } from '../catalog/slice/prod';
import Units from '../common/cmpt/priceCtrl/Units';
import AmountInput from '../common/cmpt/priceCtrl/AmountInput';
import PricePerUnit from '../common/cmpt/priceCtrl/PricePerUnit';
import Total from '../common/cmpt/priceCtrl/Total';
import Modal from '../common/cmpt/modal/Modal';
import ModalForm from '../common/cmpt/oneClick/ModalForm';
import Callback from '../app/Callback';
import ToCartFixed from './ToCartFixed';

const ValuePerUnit = ({ price, prevPrice, unit, isPromo }) => {
  return (
    <div
      className={`wfd-cnt__price ${
        prevPrice !== null || isPromo ? 'with-prev-price' : ''
      }`}
    >
      <strong>{price}</strong>
      <span>&#x20BD; /{unit}</span>
      {prevPrice !== null && (
        <small>
          {prevPrice} <b>&#x20BD;</b>
        </small>
      )}
    </div>
  );
};

const Order = ({ prod: item }) => {
  const dispatch = useDispatch();
  const { cart } = useSelector((state) => state.prod);

  const {
    id,
    unit,
    showPrice,
    isAvailable,
    showPkgMsg,
    pkgMsg,
    name,
    brand,
    brandImg,
    brandLink,
    sku,
    price,
  } = item;

  let { multiplier } = item;
  multiplier = Number(multiplier);

  const inStock = showPrice && isAvailable;
  const withPriceAndAvail = showPrice && price > 0;
  const orderformBtnTitle = withPriceAndAvail
    ? 'Купить в 1 клик'
    : 'Узнать цену';

  const inCart = cart.find(({ id: cartId }) => cartId === id);

  const [modal, setModal] = useState(false);
  const showModal = useCallback(() => setModal(true), [setModal]);
  const hideModal = useCallback(() => setModal(false), [setModal]);

  const renderPkgMsg = showPrice && showPkgMsg && pkgMsg !== '';

  const onClickConsult = () => {
    const node = document.createElement('div');
    const root = ReactDOM.createRoot(node);
    const destroy = () => {
      root.unmount();
    };

    root.render(
      <React.StrictMode>
        <Modal>
          <Callback
            destroy={destroy}
            title="Получить консультацию"
            topic="order_consult"
            prod={item.id}
          />
        </Modal>
      </React.StrictMode>,
    );
  };

  return (
    <>
      <div className="clinker__info">
        <h3>{name}</h3>
        {sku !== '' && (
          <div
            className="mobile-sku"
            onClick={() => navigator.clipboard.writeText(sku)}
            data-tooltip-id="sku-copied"
            data-tooltip-content="Артикул скопирован"
          >
            <span className="clinker__share">
              <span>Артикул: {sku}</span>
              <i className="icon sku" />
            </span>
          </div>
        )}

        <div className="clinker__stock">
          {inStock && (
            <div className="in-stock">
              <img src="/static/img/icons/tick.svg" alt="in stock" />
              <span>В наличии</span>
            </div>
          )}
          {!inStock && (
            <div className="on-order__it">
              <img src="/static/img/icons/tick1.svg" alt="in stock" />
              <span>Под заказ</span>
            </div>
          )}

          <div className="log-prem">
            <img
              src={brandImg}
              alt={brand}
              className="prod-brand-logo"
              onClick={() => (window.location.href = brandLink)}
            />
            <div className="log-official">
              <img src="/static/img/icons/shit1.svg" alt="shield" />
              <div className="log-official__hov">
                <p>Klavka Group является официальным дилером {brand}</p>
              </div>
            </div>
          </div>
        </div>

        {showPrice && (
          <div className="clinker__rea">
            <div className="wfd-cnt__res">
              <PricePerUnit
                prod={item}
                valueCmpt={ValuePerUnit}
                renderPrice={showPrice}
              />
              <Units prod={item} show={showPrice} />
            </div>
          </div>
        )}

        {!showPrice && (
          <div className="ask-for-price">
            <span className="btn__cons" onClick={showModal}>
              <span>{orderformBtnTitle}</span>
            </span>
          </div>
        )}
      </div>

      <div className="sold-multi">
        {showPrice && (
          <div
            className={`sold-multi__price ${
              renderPkgMsg ? 'with-pkg-msg' : ''
            }`}
          >
            <div className="sold-multi__add">
              <div className="add-catalog-for-shop">
                <AmountInput prod={item} />
              </div>
            </div>

            <div className="sold-multi__total">
              <span>Итого</span>
              <strong>
                <Total prod={item} wrapped />
              </strong>
              <small>&#x20BD;</small>
            </div>
          </div>
        )}

        <span className="quantity-goods">
          {renderPkgMsg && (
            <>
              {pkgMsg}: {multiplier} {unit}.
            </>
          )}
        </span>

        <div className="sold-multi__click">
          <span
            className={`btn__bas ${inCart && 'in-cart'}`}
            onClick={() => {
              if (!inCart) {
                dispatch(prod.actions.addCartItem({ id, q: multiplier }));
              }
              if (inCart) {
                window.location.href = '/cart';
              }
            }}
          >
            <img src="/static/img/icons/buy-two.svg" alt="to-cart" />
            {!inCart && <span>В корзину</span>}
            {inCart && <span>В корзине</span>}
          </span>
          <span className="btn-liner" onClick={showModal}>
            {orderformBtnTitle}
          </span>
        </div>

        <span className="btn__cons" onClick={onClickConsult}>
          <i className="icon phone-lin"></i>
          <span>Бесплатная консультация с менеджером</span>
        </span>
      </div>

      <ToCartFixed
        inCart={inCart}
        onClick={() =>
          dispatch(prod.actions.addCartItem({ id, q: multiplier }))
        }
      />

      {modal && (
        <ModalForm
          prod={item}
          inStock={withPriceAndAvail}
          onHide={hideModal}
          modal={modal}
        />
      )}
    </>
  );
};

export default Order;
